import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Vale from './Vales';
import { ValesData } from '../../types/Types';
import { useValesMasivosContext } from './context/ValesMasivos.context';

interface Props {
  valesNoAct: ValesData[];
  retrieveValesAhorro: any;
  isMobile: boolean;
  setVisible: React.Dispatch<React.SetStateAction<boolean>>;
  setPromocion: React.Dispatch<React.SetStateAction<boolean>>;
}
const ValesNoActivados: FC<Props> = ({
  valesNoAct,
  retrieveValesAhorro,
  isMobile,
  setVisible,
  setPromocion,
}) => {
  const { t, i18n } = useTranslation();
  const idiomaActual = i18n.language;
  const { cuponesMasivosActivables, formaterFecha } = useValesMasivosContext();
  const mostrarSeccion = () => {
    return valesNoAct?.length > 0 || cuponesMasivosActivables?.length > 0;
  };
  return mostrarSeccion() ? (
    <div id="vales-no-activo">
      <div className="listado-vales">
        <h2 className="bloque-datos__title u-text-brand">
          <span className="divider__square brand-color" />
          <span className="u-margin-right">{t('vales.noActivos')}</span>
        </h2>
        <div className="listado-vales__filtro" />
      </div>
      {cuponesMasivosActivables.map(
        (cuponesMasivosActivablesSegmentado, index) => {
          return (
            <div
              className="listado-vales listado-vales__activos listado-vales--masivos"
              id={`lista-vales-masivos-${index}`}
            >
              <div className="listado-vales__header">
                <h3 className="listado-vales__header-title">{`${cuponesMasivosActivablesSegmentado[0].textoTitulo}`}</h3>
                <p>{`Compra realizada el ${formaterFecha(
                  cuponesMasivosActivablesSegmentado[0]
                    .fechaEmisionValeDigitalizado,
                  idiomaActual,
                )}`}</p>
              </div>
              <div
                className="listado-vales__list"
                id={`lista-vales_list-${index}`}
              >
                {cuponesMasivosActivablesSegmentado.map((valeData) => (
                  <Vale
                    preActivado={false}
                    key={`vale-${valeData.valeEAN}`}
                    data={{
                      ...valeData,
                      masivo: true,
                      tipoLista: 5,
                      grupoIndex: index,
                    }}
                    cargarVales={retrieveValesAhorro}
                    valeIndex={isMobile ? 0 : index}
                    showCondLegales={setVisible}
                    setPromocion={setPromocion}
                  />
                ))}
              </div>
            </div>
          );
        },
      )}
      <div className="listado-vales listado-vales__activos">
        {valesNoAct
          .filter((valeData) => !valeData.masivo)
          .map((valeData, index) => (
            <Vale
              preActivado={false}
              key={`vale-${valeData.valeEAN}`}
              data={valeData}
              cargarVales={retrieveValesAhorro}
              valeIndex={isMobile ? 0 : index}
              showCondLegales={setVisible}
              setPromocion={setPromocion}
            />
          ))}
      </div>
    </div>
  ) : null;
};

export default ValesNoActivados;
